/**
 * Parses an html element with the given id as JSON.
 * Url-encoded properties will remain URL encoded.
 * Returns undefined if the element does not exist
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseJsonElementWithId(elementId) {
    var jsonElement = document.getElementById(elementId);
    // IMPORTANT: we use 'textContent' here since it fully decodes the
    // HTML-encoded content of the element. 'innerHTML' does not fully decode the contents.
    var jsonText = jsonElement && jsonElement.textContent;
    if (jsonText) {
        return JSON.parse(jsonText);
    }
    else {
        return undefined;
    }
}
//# sourceMappingURL=parseJsonElementWithId.js.map